"use client";

import { MAIN_SITE_ROUTES } from "@frontend/roz-sdk-core";
import type { ComponentProps } from "react";
import LogoBlack from "@/assets/svg/logo-black.svg?react";
import LogoWhite from "@/assets/svg/logo-white.svg?react";
import { cn } from "@/lib/cn";
import { useSdkConfig } from "@/provider";

import { NavLink } from "./NavLink";

export interface LogoProps extends ComponentProps<"div"> {
  href?: string;
}

export const Logo = ({
  className,
  href = MAIN_SITE_ROUTES.home,
  ...rest
}: LogoProps) => {
  const config = useSdkConfig();
  const isDarkTheme = config.theme === "dark";

  return (
    <div
      className={cn(
        "sdkui:-mb-2 sdkui:xs:-mb-3 sdkui:h-9 sdkui:xs:h-10 sdkui:w-30 sdkui:xs:w-34 sdkui:md:w-40 sdkui:lg:h-12",
        className
      )}
      {...rest}
    >
      <NavLink
        className="sdkui:flex sdkui:h-full sdkui:items-center"
        href={href}
      >
        {isDarkTheme ? <LogoWhite /> : <LogoBlack />}
      </NavLink>
    </div>
  );
};
